import { getAuth, signOut } from "firebase/auth";

export const logoutUser = () => {
  const auth = getAuth();
  return signOut(auth).catch((error) => {
    console.error("Error logging out user: ", error);
    alert("There was an error logging out. Please try again.");
  });
};
